import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  createHomeSlider1,
  getHomeSlider1,
  updateHomeSlider1,
} from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import removeIcon from "../../../Assets/remove-image-photo.svg";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";


export default function SlideroneEdit() {
  const { id, partnerId } = useParams();

  const [sliderone, setSliderone] = useState({
    image1: "",
    paragraph1: "",
    image2: "",
    paragraph2: "",
    image3: "",
    paragraph3: "",
    index: null,
  });
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Initial form values
  const initialValues = {
    paragraph1: sliderone.paragraph1 || "",
    paragraph2: sliderone.paragraph2 || "",
    paragraph3: sliderone.paragraph3 || "",
    image1: sliderone.image1 || "",
    image2: sliderone.image2 || "",
    image3: sliderone.image3 || "",
    old_image1: sliderone.image1 || "",
    old_image2: sliderone.image2 || "",
    old_image3: sliderone.image3 || "",
  };

  const fetchSliderData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    
    try {
      const response = await getHomeSlider1(id);
      const slideoneData = response.data.data[0];
      setSliderone({
        ...slideoneData,
        index: response.data.data.indexOf(slideoneData),
      });
    } catch (error) {
       showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to fetch slider data. Please try again.',
       });
    } finally {
        setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSliderData();
  }, [id]);
  // Validation Schema
  const validationSchema = Yup.object({
    paragraph1: Yup.string().required("Paragraph 1 is required"),
    paragraph2: Yup.string().required("Paragraph 2 is required"),
    paragraph3: Yup.string().required("Paragraph 3 is required"),
    image1: Yup.mixed()
      .test("required", "Image 1 is required", function (value) {
        const { old_image1 } = this.parent;
        return !!(value || old_image1);
      })
      .test("fileType", "Only image files are allowed", (value) => {
        if (!value || typeof value === 'string') return true;
        return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'].includes(value.type);
      }),
    image2: Yup.mixed()
      .test("required", "Image 2 is required", function (value) {
        const { old_image2 } = this.parent;
        return !!(value || old_image2);
      })
      .test("fileType", "Only image files are allowed", (value) => {
        if (!value || typeof value === 'string') return true;
        return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'].includes(value.type);
      }),
    image3: Yup.mixed()
      .test("required", "Image 3 is required", function (value) {
        const { old_image3 } = this.parent;
        return !!(value || old_image3);
      })
      .test("fileType", "Only image files are allowed", (value) => {
        if (!value || typeof value === 'string') return true;
        return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'].includes(value.type);
      }),
  });


  const handleSubmit = async (values, { setSubmitting, setFieldError, setFieldValue }) => {
    setSaving(true);

    var formData = new FormData();
    formData.append("paragraph1", values.paragraph1);
    formData.append("paragraph2", values.paragraph2);
    formData.append("paragraph3", values.paragraph3);

    if (values.image1 instanceof File) {
      formData.append("image1", values.image1);
    }

    if (values.image2 instanceof File) {
      formData.append("image2", values.image2);
    }

    if (values.image3 instanceof File) {
      formData.append("image3", values.image3);
    }

    if (!Number(id)) {
      try {
        formData.append("partner_id", partnerId);
        const res = await createHomeSlider1(formData);
        console.log(res);
        if (res.status === 200) {
          showToast({
            type: 'success',
            message: res?.data?.message || "Slider 1 section has been create successfully!",
          });
          const slideoneData = res.data.data;
          setSliderone(slideoneData);
          if (slideoneData && slideoneData.id) {
            navigate(`/${partnerId}/home/slider1/edit/${slideoneData.id}`);
          }
        } else {
          showToast({
            type: 'error',
              message: res?.data?.message || "Failed to create slider 1 section. Please try again.",
          });
          Promise.resolve();
        }
        setSaving(false);
      } catch (err) {
        showToast({
          type: 'error',
            message: err?.response?.data?.message || "Failed to create slider 1 section. Please try again.",
        });
        console.log(err);
        setSaving(false);
      }
    } else {
      try {
        const res = await updateHomeSlider1(id, formData);
        console.log(res);
        if (res.status === 200) {
          showToast({
            type: 'success',
              message: res?.data?.message || "Slider 1 section has been updated successfully!",
          });
          
          // Update the form fields with the returned image URLs if available
          const updatedSliderData = res?.data?.data;
          if (updatedSliderData) {
            if (updatedSliderData.image1) {
              setFieldValue("image1", updatedSliderData.image1);
              setFieldValue("old_image1", updatedSliderData.image1);
            }
            if (updatedSliderData.image2) {
              setFieldValue("image2", updatedSliderData.image2);
              setFieldValue("old_image2", updatedSliderData.image2);
            }
            if (updatedSliderData.image3) {
              setFieldValue("image3", updatedSliderData.image3);
              setFieldValue("old_image3", updatedSliderData.image3);
            }
            setSliderone(prev => ({
              ...prev,
              ...updatedSliderData,
            }));
          }
          
          // Clear the file inputs
          if (inputRef1.current) inputRef1.current.value = '';
          if (inputRef2.current) inputRef2.current.value = '';
          if (inputRef3.current) inputRef3.current.value = '';
        } else {
          showToast({
            type: 'error',
            message: res?.data?.message || "Failed to update slider 1 section. Please try again.",
          });
          Promise.resolve();
        }
        setSaving(false);
      } catch (err) {
        showToast({
          type: 'error',
          message: err?.response?.data?.message || "Failed to update slider 1 section. Please try again.",
        });
        console.log(err);
        setSaving(false);
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <CmsCircularProgress />
      ) : (
        <FormWrapper>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              getFieldProps,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Title>{Number(id) ? "Edit" : "Add"} Slider 1 section</Title>
                <SliderDiv>
                  <SubTitle>Slide 1</SubTitle>
                  <FormGroup
                    label="Select a new Image"
                    requiredField
                    error={touched.image1 && errors.image1 ? errors.image1 : ''}
                  >
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setFieldValue("image1", file);
                      }}
                      style={{ display: "none" }}
                      ref={inputRef1}
                      name="image1"
                    />
                    {values.image1 ? (
                      <ImageWrapper>
                        <UploadImage>
                          <BootstrapImage
                            src={values.image1 instanceof File ? URL.createObjectURL(values.image1) : values.image1}
                            alt="image1"
                            onClick={() => {
                              inputRef1.current.click();
                            }}
                          />
                        </UploadImage>
                        <br />
                        {(values.image1 instanceof File || (values.image1 && values.image1 !== values.old_image1)) && (
                          <RemoveButtonWrapper>
                            <BootstrapButton
                              type="button"
                              onClick={() => {
                                setFieldValue("image1", values.old_image1 || "");
                                if (inputRef1.current) {
                                  inputRef1.current.value = '';
                                }
                              }}
                            >
                              <img src={removeIcon} alt="removeImage" height={'20px'} width={'20px'}/>
                            </BootstrapButton>
                          </RemoveButtonWrapper>
                        )}
                      </ImageWrapper>
                    ) : (
                      (Number(id) && (values.image1 || values.old_image1)) ? 
                        <UploadImage>
                          <BootstrapImage
                            src={values.image1 || values.old_image1}
                            alt="image1"
                            onClick={() => {
                              inputRef1.current.click();
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.opacity = 0.8;
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.opacity = 1;
                            }}
                          />
                        </UploadImage> : 
                        <div>
                          <Button
                            className="w-auto mb-0"
                            onClick={() => {
                              inputRef1.current.click();
                            }}
                          >
                            Upload the image
                          </Button>
                        </div>
                    )}
                  </FormGroup>
                
                  <FormGroup
                    label="Enter a new paragraph"
                    requiredField
                    error={touched.paragraph1 && errors.paragraph1 ? errors.paragraph1 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={5}
                      {...getFieldProps('paragraph1')}
                      isInvalid={touched.paragraph1 && !!errors.paragraph1}
                    />
                  </FormGroup>

                  <SubTitle className="mt-3">Slide 2</SubTitle>
                  <FormGroup
                    label="Select a new Image"
                    requiredField
                    error={touched.image2 && errors.image2 ? errors.image2 : ''}
                  >       
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setFieldValue("image2", file);
                      }}
                      style={{ display: "none" }}
                      ref={inputRef2}
                      name="image2"
                    />
                    {values.image2 ? (
                      <ImageWrapper>
                        <UploadImage>
                          <BootstrapImage
                            src={values.image2 instanceof File ? URL.createObjectURL(values.image2) : values.image2}
                            alt="image2"
                            onClick={() => {
                              inputRef2.current.click();
                            }}
                          />
                        </UploadImage>
                        <br />
                        {(values.image2 instanceof File || (values.image2 && values.image2 !== values.old_image2)) && (
                          <RemoveButtonWrapper>
                            <BootstrapButton
                              type="button"
                              onClick={() => {
                                setFieldValue("image2", values.old_image2 || "");
                                if (inputRef2.current) {
                                  inputRef2.current.value = '';
                                }
                              }}
                            >
                              <img src={removeIcon} alt="removeImage" height={'20px'} width={'20px'}/>
                            </BootstrapButton>
                          </RemoveButtonWrapper>
                        )}
                      </ImageWrapper>
                    ) : (
                      (Number(id) && (values.image2 || values.old_image2)) ? 
                        <UploadImage>
                          <BootstrapImage
                            src={values.image2 || values.old_image2}
                            alt="image2"
                            onClick={() => {
                              inputRef2.current.click();
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.opacity = 0.8;
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.opacity = 1;
                            }}
                          />
                        </UploadImage> : 
                        <div>
                          <Button
                            className="w-auto mb-0"
                            onClick={() => {
                              inputRef2.current.click();
                            }}
                          >
                            Upload the image
                          </Button>
                        </div>
                    )}
                  </FormGroup>

                  <FormGroup
                    label="Enter a new paragraph"
                    requiredField
                    error={touched.paragraph2 && errors.paragraph2 ? errors.paragraph2 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={5}
                      {...getFieldProps('paragraph2')}
                      isInvalid={touched.paragraph2 && !!errors.paragraph2}
                    />
                  </FormGroup>

                  <SubTitle className="mt-3">Slide 3</SubTitle>
                  <FormGroup
                    label="Select a new Image"
                    requiredField
                    error={touched.image3 && errors.image3 ? errors.image3 : ''}
                  > 
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setFieldValue("image3", file);
                      }}
                      style={{ display: "none" }}
                      ref={inputRef3}
                      name="image3"
                    />
                    {values.image3 ? (
                      <ImageWrapper>
                        <UploadImage>
                          <BootstrapImage
                            src={values.image3 instanceof File ? URL.createObjectURL(values.image3) : values.image3}
                            alt="image3"
                            onClick={() => {
                              inputRef3.current.click();
                            }}
                          />
                        </UploadImage>
                        {(values.image3 instanceof File || (values.image3 && values.image3 !== values.old_image3)) && (
                          <RemoveButtonWrapper>
                            <BootstrapButton
                              type="button"
                              onClick={() => {
                                setFieldValue("image3", values.old_image3 || "");
                                if (inputRef3.current) {
                                  inputRef3.current.value = '';
                                }
                              }}
                            >
                              <img src={removeIcon} alt="removeImage" height={'20px'} width={'20px'}/>
                            </BootstrapButton>
                          </RemoveButtonWrapper>
                        )}
                      </ImageWrapper>
                    ) : (
                      (Number(id) && (values.image3 || values.old_image3)) ? 
                        <UploadImage>
                          <BootstrapImage
                            src={values.image3 || values.old_image3}
                            alt="image3"
                            onClick={() => {
                              inputRef3.current.click();
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.opacity = 0.8;
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.opacity = 1;
                            }}
                          />
                        </UploadImage> : 
                        <div>
                          <Button
                            className="w-auto mb-0"
                            onClick={() => {
                              inputRef3.current.click();
                            }}
                          >
                            Upload the image
                          </Button>
                        </div>
                    )}
                  </FormGroup>

                  <FormGroup
                    label="Enter a new paragraph"
                    requiredField
                    error={touched.paragraph3 && errors.paragraph3 ? errors.paragraph3 : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={5}
                      {...getFieldProps('paragraph3')}
                      isInvalid={touched.paragraph3 && !!errors.paragraph3}
                    />
                  </FormGroup>

                  <ButtonWrapper className="mt-3">
                    <Link
                      to={`/${partnerId}/home/slider1/view/${
                        Number(id) ? id : "create"
                      }`}
                    >
                      <Button variant="secondary">Go Back</Button>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={saving || isSubmitting}
                    >
                      {saving ? "Saving..." : "Save Changes"}
                    </Button>
                  </ButtonWrapper>
                </SliderDiv>
              </Form>
            )}
          </Formik>
        </FormWrapper>
      )}
    </>
  );
}

const FormWrapper = styled.div`
  @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const SubTitle = styled.h5``;

const RemoveButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 0 auto;
   position: absolute;
    top: -17px;
    right: -14px;
       @media (max-width:576px) {
          top: -9px;
        right: -17px;
  }
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  @media (max-width: 890px) {
        gap: 2rem;
}
 @media (max-width: 425px) {
  gap: 1rem;
}
`;
const UploadImage = styled.div`
  max-width: 15vw;
  //  border: 1px solid #ced4da;
       overflow: hidden;
       border-radius: 6px;
        @media (max-width:576px) {
   max-width: 40vw;
  }
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
const BootstrapImage = styled('img')(({ theme }) => ({
  maxWidth: "15vw",
  cursor: "pointer",
  "@media (max-width: 576px)": {
    maxWidth: "40vw",
  },
}));
const ImageWrapper = styled.div`
    position:relative;
    max-width: 15vw;
   @media (max-width:576px) {
   max-width: 40vw;
  }
`;
const  BootstrapButton = styled('button')(({ theme }) => ({
  margin: '0 !important',
  backgroundColor:'#FFFFFF',
  padding: '5px 7px',
  border: '1px solid #dc3545',
  "&:hover": {
    background: '#fffeff',
    boxShadow:'rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px'
  },
  '@media (max-width:576px)': {
    padding: '2px 4px',
  },
}));